import { useState } from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
    "w-full border-b border-white/15 bg-transparent py-3 text-base text-bone placeholder:text-silver/50 outline-none transition-colors duration-300 focus:border-bronze";

const Field = ({ label, htmlFor, children }) => (
    <div>
        <label
            htmlFor={htmlFor}
            className="mb-1 block text-[10px] font-medium uppercase tracking-[0.3em] text-silver"
        >
            {label}
        </label>
        {children}
    </div>
);

export const BookingForm = () => {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        vehicle: "",
        service: "",
        date: "",
        time: "",
        note: "",
    });
    const [state, setState] = useState("idle");

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setState("sending");
        try {
            const res = await fetch(`${API}/booking-requests`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error();
            setState("done");
        } catch {
            setState("error");
        }
    };

    if (state === "done") {
        return (
            <div
                data-testid="booking-success"
                className="border border-bronze/40 p-10 text-center md:p-14"
            >
                <p className="font-display text-3xl font-light italic text-bronze md:text-4xl">
                    Zahtjev zaprimljen.
                </p>
                <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-silver">
                    Hvala, {form.name.split(" ")[0]}. Vaš zahtjev za termin je
                    zaprimljen — javit ćemo vam se na {form.phone} radi potvrde.
                </p>
                <Link
                    to="/"
                    data-testid="booking-success-home"
                    className="mt-9 inline-block border-b border-bone/25 pb-1 text-[11px] font-medium uppercase tracking-[0.26em] text-bone/80 transition-colors hover:border-bronze hover:text-bronze"
                >
                    Povratak na početnu
                </Link>
            </div>
        );
    }

    return (
        <form onSubmit={submit} data-testid="booking-form" className="space-y-8">
            <div className="grid gap-8 sm:grid-cols-2">
                <Field label="Ime i prezime" htmlFor="bk-name">
                    <input
                        id="bk-name"
                        data-testid="booking-name-input"
                        required
                        minLength={2}
                        value={form.name}
                        onChange={set("name")}
                        placeholder="npr. Ivan Horvat"
                        className={inputCls}
                    />
                </Field>
                <Field label="Broj telefona" htmlFor="bk-phone">
                    <input
                        id="bk-phone"
                        data-testid="booking-phone-input"
                        required
                        minLength={6}
                        type="tel"
                        value={form.phone}
                        onChange={set("phone")}
                        placeholder="npr. 063 000 000"
                        className={inputCls}
                    />
                </Field>
            </div>

            <div className="grid gap-8 sm:grid-cols-2">
                <Field label="Vrsta vozila" htmlFor="bk-vehicle">
                    <input
                        id="bk-vehicle"
                        data-testid="booking-vehicle-input"
                        required
                        minLength={2}
                        value={form.vehicle}
                        onChange={set("vehicle")}
                        placeholder="npr. Golf 8, limuzina, SUV…"
                        className={inputCls}
                    />
                </Field>
                <Field label="Usluga" htmlFor="bk-service">
                    <select
                        id="bk-service"
                        data-testid="booking-service-select"
                        required
                        value={form.service}
                        onChange={set("service")}
                        className={`${inputCls} appearance-none bg-[#0a0a0b]`}
                    >
                        <option value="" disabled>
                            Odaberite uslugu
                        </option>
                        {SERVICES.map((s) => (
                            <option key={s.num} value={s.title}>
                                {s.title}
                            </option>
                        ))}
                        <option value="SAVJET">Nisam siguran — trebam savjet</option>
                    </select>
                </Field>
            </div>

            <div className="grid gap-8 sm:grid-cols-2">
                <Field label="Željeni datum" htmlFor="bk-date">
                    <input
                        id="bk-date"
                        data-testid="booking-date-input"
                        required
                        type="date"
                        value={form.date}
                        onChange={set("date")}
                        style={{ colorScheme: "dark" }}
                        className={inputCls}
                    />
                </Field>
                <Field label="Željeno vrijeme" htmlFor="bk-time">
                    <input
                        id="bk-time"
                        data-testid="booking-time-input"
                        required
                        type="time"
                        value={form.time}
                        onChange={set("time")}
                        style={{ colorScheme: "dark" }}
                        className={inputCls}
                    />
                </Field>
            </div>

            <Field label="Napomena (neobavezno)" htmlFor="bk-note">
                <textarea
                    id="bk-note"
                    data-testid="booking-note-input"
                    rows={3}
                    maxLength={1000}
                    value={form.note}
                    onChange={set("note")}
                    placeholder="Stanje vozila, posebne želje…"
                    className={`${inputCls} resize-none`}
                />
            </Field>

            {state === "error" && (
                <p data-testid="booking-error" className="text-sm text-red-400">
                    Došlo je do greške — pokušajte ponovno ili nas nazovite.
                </p>
            )}

            <button
                type="submit"
                data-testid="booking-submit-button"
                disabled={state === "sending"}
                className="w-full bg-bone py-5 text-[12px] font-semibold tracking-[0.28em] text-[#0a0a0b] transition-colors duration-300 hover:bg-bronze disabled:opacity-50 sm:w-auto sm:px-14"
            >
                {state === "sending" ? "ŠALJEM…" : "POŠALJI ZAHTJEV ZA TERMIN"}
            </button>
        </form>
    );
};
